import { useCallback, useEffect, useRef, useState } from "react"
import { Template } from "../../Components/Template/template"
import {
    AlertType, Bandeira, barraVermelhoAzul, bgBlue, bgRed, classBorderLabelDark, classBt, classbtAzul, classbtCinzaClaro, classbtColunasVermelho,
    classDivBackground, classDivBody, classDtCriarAtt, classInput, classInputDark, classLabel, classLabelDark, classUserCriarAtt, classWeigthBt, Clientes,
    focusLabelRed, focusRed, InputsRefs, LanctoCartaoaAttributes
} from "../../Utils/Types"
import moment from "moment"
import { faClipboardList, faFolder } from "@fortawesome/free-solid-svg-icons"
import { useParams } from "react-router-dom"
import { FeedbackMessage } from "../../Components/FeedbackMessage/feedback-message"
import { FcNook } from "react-icons/fc"
import { Icone } from "../../Components/Icones/Index"
import { FaRegQuestionCircle } from "react-icons/fa"
import { BsBoxArrowInLeft } from "react-icons/bs"
import { Link } from "react-router-dom"
import { IoSave } from "react-icons/io5"
import { AiOutlineClear } from "react-icons/ai"
import { Tooltip } from 'react-tooltip'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { Funcoes } from "../../Utils/Funcoes"
import { LanctoCartaoService } from "./LanctoCartaoService"
import { SearchBox } from "../../Components/SearchBox/SearchBox"
import { BandeiraService } from "../Bandeira/BandeiraService"

type CampoObrigatorio = {
    campo: string,
    erro: boolean,
}

export const LancamentoCartaoNew = () => {

    // ----------------- TABS --------------------------------------------------------
    type Tab = {
        index: number,
        titulo: String,
        active: boolean,
        icon: IconProp,
    }

    const itabs: Tab[] = [
        { index: 0, titulo: 'Dados Principais', active: true, icon: faFolder },
        { index: 1, titulo: 'Auditoria', active: false, icon: faClipboardList },
    ]

    const [tabs, setTabs] = useState<Tab[]>(itabs)

    // ------------------ ATRIBUTOS ---------------------------------------------------
    const { idLanctoCartao } = useParams<string>()
    const [id, setId] = useState(0)
    const [attributes, setAttributes] = useState<LanctoCartaoaAttributes>()

    let date = moment().utcOffset('-03:00')

    const [numTransacao, setNumTransacao] = useState("")
    const [dtChegada, setDtChegada] = useState(date.format('YYYY-MM-DD'))
    const [dtVencimento, setDtVencimento] = useState("")
    const [valor, setValor] = useState("0.00")
    const [valorReceber, setValorReceber] = useState("0.00")
    const [taxa, setTaxa] = useState(0)
    const [dias, setDias] = useState('')

    // CLIENTE
    const [idCliente, setIdCliente] = useState(0)
    const [clienteList, setClienteList] = useState<Clientes[]>([])

    // BANDEIRA
    const [idBandeira, setIdBandeira] = useState(0)
    const [bandeiraList, setBandeiraList] = useState<Bandeira[]>([])

    // ---------- ATRIBUTOS FEEDBACK -------------------------------------------------
    const [loading, setLoading] = useState(false)
    const [visible, setVisible] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    // ---------- ATRIBUTOS AUDITORIA -------------------------------------------------
    const [userCriador, setUserCriador] = useState("")
    const [dtCriador, setDtCriador] = useState("")
    const [usertAtt, setUsertAtt] = useState("")
    const [dtAtt, setDtAtt] = useState("")

    // --------- SEARCHBOX ------------------------------------------------------------
    const [visibleSearchBoxCliente, setVisibleSearchBoxCliente] = useState<boolean>(false)
    const [visibleSearchBoxBandeira, setVisibleSearchBoxBandeira] = useState<boolean>(false)

    // ---------- ATRIBUTOS TUTORIAL ----------------------------------
    const [modalTutorialVisible, setModalTutorialVisible] = useState(false)


    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ATRIBUTOS E EFFECT --------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ || 
    const getAttributes = async () => {

        setVisible(false)
        setLoading(true)

        try {

            const lanctoCartaoAttributes = await LanctoCartaoService.GetAttributes(idLanctoCartao)
            setAttributes(lanctoCartaoAttributes.data)

            setClienteList(lanctoCartaoAttributes.data.cliente)
            setBandeiraList(lanctoCartaoAttributes.data.bandeira)

            if (lanctoCartaoAttributes.data.lanctoCartao && idLanctoCartao) {

                const bandeira = lanctoCartaoAttributes.data.bandeira.filter((item: any) => item.id === lanctoCartaoAttributes.data.lanctoCartao.id_bandeira)
                if (bandeira && bandeira.length > 0) {
                    setIdBandeira(bandeira[0].id)
                }

                const cliente = lanctoCartaoAttributes.data.cliente.filter((item: any) => item.id === lanctoCartaoAttributes.data.lanctoCartao.id_cliente)
                if (cliente && cliente.length > 0) {
                    setIdCliente(cliente[0].id)
                }

                setId(lanctoCartaoAttributes.data.lanctoCartao.id || 0)
                setNumTransacao(lanctoCartaoAttributes.data.lanctoCartao.numero_transacao || '')
                setDtChegada(lanctoCartaoAttributes.data.lanctoCartao.dt_chegada || '')
                setDtVencimento(lanctoCartaoAttributes.data.lanctoCartao.dt_vencimento || '')
                setValor(lanctoCartaoAttributes.data.lanctoCartao.valor || '0.00')
                setValorReceber(lanctoCartaoAttributes.data.lanctoCartao.valor_receber || '0.00')
                //setIdBandeira(lanctoCartaoAttributes.data.lanctoCartao.id_bandeira || 0)
                //setIdCliente(lanctoCartaoAttributes.data.lanctoCartao.id_cliente || 0)
                setUserCriador(lanctoCartaoAttributes.data.lanctoCartao.name_user_insert || '')
                setUsertAtt(lanctoCartaoAttributes.data.lanctoCartao.name_user_last_update || '')

                if (lanctoCartaoAttributes.data.lanctoCartao.dt_cadastro) {
                    const dataFormatadaCriacao = moment(lanctoCartaoAttributes.data.lanctoCartao.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (lanctoCartaoAttributes.data.lanctoCartao.dt_last_update) {
                    const dataFormatadaAtt = moment(lanctoCartaoAttributes.data.lanctoCartao.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                const dados = await BandeiraService.GetAttributes(lanctoCartaoAttributes.data.lanctoCartao.id_bandeira || 0)

                if (dados.data) {
                    setTaxa(dados.data.taxa)
                    setDias(dados.data.dias)
                }

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível carregar os dados`)

        } finally {
            setLoading(false)
        }

    }

    useEffect(() => {
        getAttributes()
        inputFocus()
    }, [])

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

        inputFocus()
    }, [])

    const handleChangeTab = async (tab: number) => {
        let newTabs = await tabs.map((item) => {
            if (item.index === tab) {
                itabs[item.index].active = true
            } else {
                itabs[item.index].active = false
            }
            return itabs[item.index]
        })
        setTabs(newTabs)
    }

    useEffect(() => {

        if (tabs[0].active) {
            inputFocus()
        }

    }, [tabs])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- INPUTS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const numTransacaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNumTransacao(e.target.value.replace(/[^0-9]/g, ''))
    }

    const dtChegadaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDtChegada(e.target.value)

        const vencimento = moment(e.target.value).clone().add(dias, 'days').format('YYYY-MM-DD')
        setDtVencimento(vencimento)
    }

    const dtVencimentoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDtVencimento(e.target.value)
    }

    const valorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValor(Funcoes.MaskMoney(e.target.value))

        const vlReceber = (parseFloat(Funcoes.MaskMoney(e.target.value)) * (1 - (taxa / 100))).toFixed(2)
        setValorReceber(vlReceber.toString())
    }

    const valorReceberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValorReceber(Funcoes.MaskMoney(e.target.value))
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- BANDEIRA ------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearBandeiraSelecionada = useCallback(() => {

        setIdBandeira(0)
        setVisibleSearchBoxBandeira(false)

    }, [attributes?.bandeira])

    const handleFilterBandeiraClick = useCallback(async (description: string) => {

        if (description.trim() === "") {

            const newBandeiraList = [...attributes?.bandeira || []]
            setBandeiraList(newBandeiraList)

        } else {

            const newBandeiraList = [...attributes?.bandeira || []].filter((item) => {
                return item.description?.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            setBandeiraList(newBandeiraList || [])
        }
    }, [attributes?.bandeira])

    const handleBandeiraSelectClick = useCallback(async (v: Bandeira) => {

        if (v) {
            setIdBandeira(v.id)
        } else {
            setIdBandeira(0)
        }

        setLoading(true)
        const dados = await BandeiraService.GetAttributes(v.id.toString())

        if (dados.data) {

            const vencimento = dtChegada != '' ? moment(dtChegada).clone().add(dados.data.dias, 'days').format('YYYY-MM-DD') : date.clone().add(dados.data.dias, 'days').format('YYYY-MM-DD')
            const vlReceber = (parseFloat(valor) * (1 - (dados.data.taxa / 100))).toFixed(2)

            setDtVencimento(vencimento)
            setTaxa(dados.data.taxa)
            setDias(dados.data.dias)
            setValorReceber(vlReceber.toString())

        }
        setLoading(false)

        setVisibleSearchBoxBandeira(false)

    }, [attributes?.bandeira, valor, dtChegada])

    const clickSearchBoxBandeira = useCallback(() => {
        setVisibleSearchBoxBandeira((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {

                setVisibleSearchBoxCliente(false)
                inputFocusBandeira()
            }
            return newState
        })
    }, [])

    const inputFocusBandeira = () => {
        let inputSearch = document.getElementById(`inputSearchBox-bandeira`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CLIENTE -------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearClienteSelecionada = useCallback(() => {

        setIdCliente(0)
        setVisibleSearchBoxCliente(false)

    }, [attributes?.cliente])

    const handleFilterClienteClick = useCallback(async (description: string) => {

        if (description.trim() === "") {


            const newClienteList = [...attributes?.cliente || []]
            setClienteList(newClienteList)

        } else {

            const newClienteList = [...attributes?.cliente || []].filter((item) => {
                return item.description?.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })

            setClienteList(newClienteList || [])
        }
    }, [attributes?.cliente])

    const handleClienteSelectClick = useCallback((v: Clientes) => {

        if (v) {
            setIdCliente(v.id)
        } else {
            setIdCliente(0)
        }

        setVisibleSearchBoxCliente(false)

    }, [attributes?.cliente])

    const clickSearchBoxCliente = useCallback(() => {
        setVisibleSearchBoxCliente((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {

                setVisibleSearchBoxBandeira(false)
                inputFocusCliente()
            }
            return newState
        })
    }, [])

    const inputFocusCliente = () => {
        let inputSearch = document.getElementById(`inputSearchBox-cliente`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------ LANÇAMENTO CARTAO ----------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const novoLancamentoCartao = () => {
        setId(0)
        setNumTransacao("")
        setDtVencimento("")
        setValor("0.00")
        setValorReceber("0.00")
        setIdBandeira(0)
        setIdCliente(0)
        setTaxa(0)

        setDtCriador('')
        setDtAtt('')
        setUserCriador('')
        setUsertAtt('')

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        inputFocus()
    }

    const handleSaveLancamentoCartao = async () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        setLoading(true)

        try {

            let lanctoCartao: any = {
                numero_transacao: numTransacao,
                dt_chegada: dtChegada,
                dt_vencimento: dtVencimento,
                valor: parseFloat(valor),
                valor_receber: parseFloat(valorReceber),
                id_bandeira: idBandeira,
                id_cliente: idCliente,
            }

            if (id > 0) {
                lanctoCartao.id = id
            }

            const resp = await LanctoCartaoService.Save(lanctoCartao)


            if (resp.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(resp.msg || ``)

            } else {

                setVisible(true)
                setMessageType("SUCCESS")
                setId(resp.id || 0)
                setMessage(id > 0 ? `Dados do lançamento do cartão atualizados com sucesso` : resp.msg || ``)

                if (resp.dt_cadastro) {
                    const dataFormatadaCriacao = moment(resp.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (resp.dt_last_update) {
                    const dataFormatadaAtt = moment(resp.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                setUserCriador(resp.name_user_insert || '')
                setUsertAtt(resp.name_user_last_update || '')
            }


        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(id > 0 ? `Não foi possível atualizar o lançamento do cartão. Por favor, tente novamente` : `Não foi possível salvar o lançamento do cartão. Por favor, tente novamente`)

        } finally {
            const timer = setTimeout(() => {
                setLoading(false)
                inputFocus()
                clearTimeout(timer)
            }, 1200)
        }
    }

    const inputFocus = () => {
        const inputElement = document.getElementById("num_transacao")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- TAB ------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const inputsRefs: InputsRefs = {
        numTransacao: useRef(null),
        bandeira: useRef(null),
        dataChegada: useRef(null),
        dataVencimento: useRef(null),
        valor: useRef(null),
        cliente: useRef(null),
    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab') {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            searchBoxFocus()

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length
            } while (
                (inputsRefs[keys[nextIndex]].current?.disabled || inputsRefs[keys[nextIndex]].current?.tabIndex === -1) &&
                nextIndex !== currentIndex
            )

            //console.log("nextIndex: ", nextIndex)

            if (nextIndex === 1) {
                setVisibleSearchBoxBandeira(true)
                inputFocusBandeira()
            }

            if (nextIndex === 5) {
                setVisibleSearchBoxCliente(true)
                inputFocusCliente()
            }

            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            inputsRefs[keys[nextIndex]].current?.focus()
        }
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab') {

                event.preventDefault()

                const inputSearchBandeira = document.getElementById('inputSearchBox-bandeira') as HTMLInputElement
                const inputSearchCliente = document.getElementById('inputSearchBox-cliente') as HTMLInputElement

                if (document.activeElement === inputSearchBandeira) {

                    inputsRefs['dataChegada'].current?.focus()
                    setVisibleSearchBoxBandeira(false)

                } else if (document.activeElement === inputSearchCliente) {
                    inputsRefs['numTransacao'].current?.focus()
                    setVisibleSearchBoxCliente(false)
                }
            }
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [])

    const searchBoxFocus = () => {
        setVisibleSearchBoxBandeira(false)
        setVisibleSearchBoxCliente(false)
    }

    const btNovoVisible = parseInt(idLanctoCartao || '') > 0 ? 'invisible hidden' : 'visible'

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div id='div-body' className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-lg`}>

                        <div className={`h-[50px] w-full flex items-center my-3 px-2`}>
                            <FcNook className={`ml-2 mr-2`} size="25px" color='#333' />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200 break-all mx-2`}>{parseInt(idLanctoCartao || '') || id > 0 ? `Editar - Lançamento - Cartão` : 'Cadastro - Lançamento - Cartão'}</span>
                        </div>

                        <div className={`w-full h-full`}>

                            <div className={`h-[60px] flex overflow-x-auto scrollable_horizontal border border-slate-200 dark:border-slate-700`}>
                                {tabs.map((item) => {
                                    return (
                                        <button tabIndex={-1} onClick={() => handleChangeTab(item.index)} key={item.index.toString()}
                                            className={`px-4 font-mono font-bold w-[180px]
                                                        ${item.active ?
                                                    `hover:text-sky-500 text-sky-600 border border-b-[3px] border-l-0 border-t-0 border-r-slate-300 border-b-sky-600 dark:text-slate-200 dark:border-r-slate-700 dark:border-b-slate-300` :
                                                    `text-sky-600 dark:text-slate-300 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 border border-l-0 border-t-0 border-b-0 dark:border-slate-800`
                                                } `}>
                                            <div tabIndex={-1} className={`flex items-center whitespace-nowrap`}>
                                                <span className={`mr-2`}><Icone icon={item.icon} /></span>
                                                <span className={`text-sm roboto whitespace-nowrap`}>{item.titulo}</span>
                                            </div>
                                        </button>
                                    )
                                })}

                            </div>

                            <div className={`${tabs[0].active ? 'block' : 'hidden'} relative`}>

                                <div className={`w-full h-full grid gap-5 grid-cols-12 p-4`}>

                                    <div className={`relative col-span-12 space-y-1`}>
                                        <div className={`flex flex-row `}>
                                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300 mr-2`}>Dados do Lançamento</span>
                                            <FaRegQuestionCircle tabIndex={-1} data-tooltip-id={'tooltip-btn-question'} id={'btn-question'} className={`text-[#ACACAC] dark:text-slate-300 cursor-pointer`} size={18} />
                                            <Tooltip id={'tooltip-btn-question'} anchorSelect={'#btn-question'} positionStrategy="fixed" place='top' >
                                                <span >Os campos com borda <br /> vermelha são obrigatórios</span>
                                            </Tooltip>
                                        </div>

                                        <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2`}>

                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.numTransacao} onKeyDown={(e) => handleTabPress(e, 'numTransacao')} id="num_transacao" className={`${classInput} ${classInputDark}`} type='text' inputMode='numeric' maxLength={45} autoComplete='off' placeholder=" " value={numTransacao} onFocus={searchBoxFocus} onChange={numTransacaoChange} />
                                        <label htmlFor="num_transacao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Num. Transação</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-8 xl:col-span-3 2xl:col-span-4`}>

                                        <div ref={inputsRefs['bandeira']} tabIndex={0} onKeyDown={(e) => handleTabPress(e, 'bandeira')} />
                                        <div className={`${barraVermelhoAzul} ${idBandeira > 0 ? bgBlue : bgRed}`} />
                                        <SearchBox
                                            dataList={bandeiraList}
                                            idRegistro={idBandeira || undefined}
                                            label='Bandeira'
                                            componentId='bandeira'
                                            borda={true}
                                            visibleTAB={visibleSearchBoxBandeira}
                                            clearDataClick={handleClearBandeiraSelecionada}
                                            setDataClick={handleBandeiraSelectClick}
                                            filterDataClick={handleFilterBandeiraClick}
                                            clicado={clickSearchBoxBandeira}
                                        />

                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2`}>

                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.dataChegada} onKeyDown={(e) => handleTabPress(e, 'dataChegada')} id="dt_chegada" className={`${classInput} ${classInputDark} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" value={dtChegada} onFocus={searchBoxFocus} onChange={dtChegadaChange} />
                                        <label htmlFor="dt_chegada" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} `}>Data de Chegada</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2`}>

                                        <div className={`${barraVermelhoAzul} ${dtVencimento != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.dataVencimento} onKeyDown={(e) => handleTabPress(e, 'dataVencimento')} id="dt_vencimento" className={`${classInput} ${classInputDark} ${dtVencimento != '' ? '' : focusRed} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" value={dtVencimento} onFocus={searchBoxFocus} onChange={dtVencimentoChange} />
                                        <label htmlFor="dt_vencimento" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${dtVencimento != '' ? '' : focusLabelRed}`}>Data de Vencimento</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2`}>

                                        <div className={`${barraVermelhoAzul} ${valor != '0.00' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.valor} onKeyDown={(e) => handleTabPress(e, 'valor')} id="valor" className={`${classInput} ${classInputDark} ${valor != '0.00' ? '' : focusRed}`} type='text' inputMode='numeric' autoComplete='off' placeholder=" " value={valor} onFocus={searchBoxFocus} onChange={valorChange} />
                                        <label htmlFor="valor" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${valor != '0.00' ? '' : focusLabelRed}`}>Valor</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2`}>

                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input id="valor_receber" className={`${classInput} ${classInputDark}`} type='text' inputMode='numeric' autoComplete='off' placeholder=" " disabled={true} value={valorReceber} onChange={valorReceberChange} />
                                        <label htmlFor="valor_receber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor a Receber</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-8 xl:col-span-6`}>

                                        <div ref={inputsRefs['cliente']} tabIndex={0} onKeyDown={(e) => handleTabPress(e, 'cliente')} />
                                        <div className={`${barraVermelhoAzul} ${idCliente !== 0 ? bgBlue : bgRed}`} />
                                        <SearchBox
                                            dataList={clienteList}
                                            idRegistro={idCliente || undefined}
                                            label='Cliente'
                                            componentId='cliente'
                                            borda={true}
                                            visibleTAB={visibleSearchBoxCliente}
                                            clearDataClick={handleClearClienteSelecionada}
                                            setDataClick={handleClienteSelectClick}
                                            filterDataClick={handleFilterClienteClick}
                                            clicado={clickSearchBoxCliente}

                                        />

                                    </div>

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/lanctoCartao" className={`${classbtColunasVermelho} ${classWeigthBt}`}>
                                        <BsBoxArrowInLeft size="20px" className={`mr-[5px]`} /> Voltar
                                    </Link>

                                    <button tabIndex={-1} onClick={novoLancamentoCartao} className={`${classBt} ${btNovoVisible} ${classbtCinzaClaro} ${classWeigthBt}`}>
                                        <AiOutlineClear size="20px" className={`mr-[5px]`} />Limpar Campos
                                    </button>

                                    <button tabIndex={-1} onClick={handleSaveLancamentoCartao} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt}`} >
                                        {!loading && <IoSave size="16px" className={`mr-[5px]`} />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {parseInt(idLanctoCartao || '0') > 0 || id != 0 ? !loading ? 'Atualizar' : 'Aguarde' : !loading ? 'Salvar' : 'Aguarde'}
                                    </button>

                                </div>

                            </div>

                            <div className={`${tabs[1].active ? 'block' : 'hidden'} relative h-[400px] sm:h-[200px]`}>

                                <div className={`w-full h-full flex flex-row p-4`}>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userCriacaoGrupo" className={`${classUserCriarAtt}`}>Criador</label>
                                            <span id="userCriacaoGrupo" className={`${classDtCriarAtt}`} >{userCriador}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtCriacaoGrupo" className={`${classUserCriarAtt}`}>Data de Criação</label>
                                            <span id="dtCriacaoGrupo" className={`${classDtCriarAtt}`} >{dtCriador}</span>
                                        </div>

                                    </div>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userAttGrupo" className={`${classUserCriarAtt}`}>Atualizador</label>
                                            <span id="userAttGrupo" className={`${classDtCriarAtt}`} >{usertAtt}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtAttGrupo" className={`${classUserCriarAtt}`}>Data de Atualização</label>
                                            <span id="dtAttGrupo" className={`${classDtCriarAtt}`}>{dtAtt}</span>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </Template>
    )
}